import { Open_Sans } from 'next/font/google';

const openSans = Open_Sans({
  weight: ['400', '500', '600', '700'],
  style: ['normal', 'italic'],
  subsets: ['latin'],
  display: 'swap',
  variable: '--title-font-family',
  preload: true,
  /**
   * Disable automatic font fallback — the generated fallback metrics for Open Sans
   * produce a poor visual match, so we rely on the default sans-serif stack instead.
   */
  adjustFontFallback: false,
});

export default openSans;
